import { StyledFrequencyOption, StyledIcon, StyledPopular } from './style';
import Selectable from '../selectable';

import fortyFiveIcon from '../../assets/forty-five.svg';
import everyOtherWeekyIcon from '../../assets/every-other-week.svg';
import monthlyIcon from '../../assets/monthly.svg';
import popularTag from '../../assets/popular.svg';

const icons = {
  fortyFive: fortyFiveIcon,
  everyOtherWeeky: everyOtherWeekyIcon,
  monthly: monthlyIcon,
}

function FrequencyOption(props){
  let className = props.current === props.frequency ? 'current' : '';

  return (
    <StyledFrequencyOption className={className} onClick={props.onClick}>
      <Selectable className={className}>
        {props.popular ? <StyledPopular src={popularTag} /> : ''}

        <StyledIcon>
          <img src={icons[props.icon]} alt={props.title} />
        </StyledIcon>

        <div className="title">{props.title}</div>
      </Selectable>
    </StyledFrequencyOption>
  )
}

export default FrequencyOption;
